<template>
  <div class="divrow mt-2 mb-2">
    <div class="divcol">
      <div class="divcol1">
        <div>
          <img
            src="@/assets/images/kubota/h gif/output-onlinegiftools (26).gif"
          />
        </div>
        <div>
          <h2>Temperature</h2>
        </div>
      </div>
      <div class="divcol2">
        <h2>
          {{ get_data.temp }}
        </h2>
        <h4>°C</h4>
      </div>
    </div>
    <div class="divcol">
      <div class="divcol1">
        <div style="width: 30%">
          <img
            style="width: 100%"
            src="@/assets/images/kubota/h gif/output-onlinegiftools (27).gif"
          />
        </div>
        <div style="width: 70%">
          <h2>Relative Humidity</h2>
        </div>
      </div>
      <div class="divcol2">
        <h2>
          {{ get_data.humid }}
        </h2>
        <h4>%</h4>
      </div>
    </div>
    <div class="divcol">
      <div class="divcol1">
        <div style="width: 30%">
          <img
            style="width: 100%"
            src="@/assets/images/kubota/h gif/output-onlinegiftools (32).gif"
          />
        </div>
        <div style="width: 70%">
          <h2>Wind Speed</h2>
        </div>
      </div>
      <div class="divcol2">
        <h2>
          {{ get_data.wind_speed }}
        </h2>
        <h4>m/s</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["get_data"],
};
</script>

<style scoped>
.divrow {
  display: flex;
  width: 100%;
}
.divcol {
  width: calc(100% / 3);
  display: grid;
  align-items: stretch;
  padding: 5px;
  margin-right: 4px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 20px;
}
.divcol1 {
  display: flex;
  align-items: center;
}
.divcol1 h2 {
  font-size: 0.8vw;
  /* white-space: nowrap; */
  font-weight: 800;
}
.divcol1 img {
  width: 50px;
  height: 40px;
}
.divcol2 {
  display: flex;
  justify-content: center;
  align-items: baseline;
}
.divcol2 h2 {
  font-weight: 800;
}
</style>